export const en = {
	aboutDescription2:
		"We also offer a wide range of candles that will complement your festive mood perfectly. Choose candles in various colors, shapes, and sizes to create the best atmosphere for your special moment.",
	aboutDescription:
		"At Valley Arts, we offer a wide selection of unique and elegant cake toppers that will add a distinctive look to your festive dessert. Our toppers are not just accessories; they embody your individuality. You will find toppers to suit every taste and theme.",
	aboutFeature2: "Fast order fulfillment times",
	aboutFeature3: "Quick shipping to get your goods to you as soon as possible",
	aboutFeature4: "Since 2015, we have created over 10,000 products",
	aboutFeature5: "We fulfill custom orders",
	aboutFeature6: "No minimum order requirements",
	aboutFeature: "Stylish toppers and candles for every occasion",
	aboutFooterDescription:
		"We are ready to collaborate with bakeries, holiday shops, balloon stores, and confectionery stores.",
	aboutFooterTitle:
		"At Valley Arts, we are always happy to see you and help make your cakes even more vibrant. Place your order today and choose the perfect topper and candles. It's time to create beauty together.",
	aboutTitle2: "welcome to the store",
	aboutTitle3: "valley arts is a Ukrainian brand of cake decor",
	aboutTitle: "about valley arts",
	aboutUs: "about us",
	accept: "Accept",
	addCustomText: "add custom text",
	addToCart: "add to cart",
	allProducts: "all products",
	bestSellingProducts: "best selling products",
	cancel: "cancel",
	card: "card",
	cart: "cart",
	cartDescription: "manage your items",
	cartTotals: "cart totals",
	callback: "call back",
	category: "category",
	checkout: "checkout",
	checkoutDescription: "checkout your items",
	checkoutWarnMessage2: "checkout",
	checkoutWarnMessage3: "or",
	checkoutWarnMessage4: "cancel",
	checkoutWarnMessage:
		"you have an active order ready to checkout. Please proceed through",
	code: "code",
	collection: "collection | collections",
	color: "color | colors",
	convenientCheckout: "convenient checkout",
	convenientCheckoutDescription: "fast order processing",
	cookiePreferences: "Cookie Preferences",
	cost: "cost",
	customText: "custom text",
	checkoutOrder: "Checkout",
	contactDetails: "Your contact details",
	date: "date",
	decline: "Decline",
	delivery: "delivery",
	deliveryTitle: "Delivery \"Nova post\"",
	deliveryAcrossUkraine: "delivery across Ukraine",
	deliveryAcrossUkraineDescription: "shipped by \"Nova Post\" every working day",
	deliveryInfoMessage: "according to the carrier's rates",
	discount: "discount",
	division: "Branch/Postomat or their address",
	emptyCartMessage: "currently you have no products in your cart",
	email: "Email",
	emailError: "Enter your email",
	faq: "FAQ",
	faqQuestion1Description3:
		"Then simply provide your delivery details and make the payment.",
	faqQuestion1Description:
		"Choose the desired decor, size, color, optionally add text (if available), and add it to your cart. Proceed to the cart, review your order, and click the",
	faqQuestion1Title: "How to place an order?",
	faqQuestion2Description2:
		"You can also measure with a ruler against the cake pans or consult with a baker to determine the best size. It all depends on your preference whether you want a larger or smaller topper.",
	faqQuestion2Description:
		"Use a convenient table correlating standard cake diameters to toppers of various sizes from 10 to 15 cm.",
	faqQuestion2Title: "How to choose the right size for the cake?",
	faqQuestion3Description2: "from",
	faqQuestion3Description3: "within Kyiv",
	faqQuestion3Description4: "to other cities",
	faqQuestion3Description5:
		"The cost depends on the package dimensions and estimated value. We specify the full value for shipment insurance.",
	faqQuestion3Description: "We ship with «Nova Post» delivery service.",
	faqQuestion4Description10:
		"CLEAN WITH CHLORHEXIDINE CAREFULLY (do not clean with alcohol).",
	faqQuestion4Description11: "Be careful with the toppers.",
	faqQuestion4Description12: "Thank you for your understanding!",
	faqQuestion4Description2:
		"WHEN SENDING TO A POST MACHINE, ACCORDING TO POSTAL RULES, YOU CANNOT RECEIVE COMPENSATION IN CASE OF LOSS OR DAMAGE.",
	faqQuestion4Description3:
		"CHECK ALL COMPONENTS, COLOR, AND SIZE ON THE DAY OF RECEIPT!",
	faqQuestion4Description4:
		"IF CHECKING AT HOME OR ON ANOTHER DAY, THE RESPONSIBILITY LIES SOLELY WITH THE RECIPIENT.",
	faqQuestion4Description5:
		"ACRYLIC IS A VERY DELICATE, FRAGILE MATERIAL! HANDLE WITH CARE.",
	faqQuestion4Description6: "HANDLE WITH CARE WHEN REMOVING FROM PACKAGING.",
	faqQuestion4Description7: "HANDLE WITH CARE WHEN REMOVING THE FILM.",
	faqQuestion4Description8:
		"All toppers and decor have protective film. The film may be white or transparent. Remove on a solid surface.",
	faqQuestion4Description9:
		"CAREFULLY INSERT INTO THE CAKE (especially if it's ganache topping).",
	faqQuestion4Description:
		"INSPECT THE PACKAGE UPON RECEIPT AT THE POST OFFICE. ONLY THEN CAN WE FILE A CLAIM FOR COMPENSATION AND REPLACE THE ITEM IN THE NEAREST WORKING DAYS.",
	faqQuestion4Title: "What if the topper is broken, what should I do?",
	faqTitle: "frequently asked questions",
	filter: "filter",
	firstName: "First name",
	firstNameError: "Enter your first name",
	forWholesaleCooperation: "for wholesale cooperation",
	free: "free",
	goBack: "go back",
	home: "home",
	information: "information",
	inputCustomTextPlaceholder: "your custom text",
	inputCustomTextRegExpError: "use a maximum of 4 words",
	inputCustomTextRequiredError: "write your custom text",
	inputSearchProductsPlaceholder: "search products...",
	material: "material | materials",
	next: "next",
	nextPage: "next page",
	orderDetails: "order details",
	orderNumber: "order number",
	orderReceiptDescription:
		"thank you for your trust. Wait for shipment and tracking number.",
	orderReceiptTitle: "your order has been received!",
	orderNote: "Order note (optional)",
	lastName: "Last name",
	lastNameError: "Enter your last name",
	pageNotFoundDetails: "Sorry, we couldn't find the page you where looking for",
	pageNotFoundMessage: "page not found",
	paymentMethod: "payment method",
	payment: "Payment",
	paymentDescription: "Complete your payment",
	previous: "previous",
	previousPage: "previous page",
	product: "product | products",
	productCategories: "product categories",
	productionTime: "production time",
	productionTimeDescription: "up to 2 business days",
	publicOffer: "Public offer",
	privacyPolicy: "Privacy policy",
	phoneNumber: "Phone number",
	phoneNumberError: "Enter your phone number",
	placeOrder: "Place order",
	payByCard: "Pay by card",
	pay: "Pay",
	paymentHint: "Your order has been created but is awaiting payment. To pay, follow the link by clicking the \"Pay\" button.",
	paymentHint2: "Please note that the payment link is valid for 24 hours.",
	quantity: "quantity",
	receipt: "receipt",
	receiptDescription: "review your order summary",
	recentlyViewed: "recently viewed",
	seeAllProducts: "see all products",
	settlement: "Settlement",
	shop: "shop",
	shopNow: "shop now",
	showMore: "show more",
	size: "size | sizes",
	subtotal: "subtotal",
	tag: "tag | tags",
	total: "total",
	viewCart: "view cart",
	workingHours: "working hours",
	workingHoursWeekdays: "Mon - Fri: 9:00 AM - 8:00 PM",
	workingHoursWeekend: "Sat - Sun: Closed (no shipments)",
	cookieAgreement: {
		title: "Cookie Consent",
		description: [
			"We use essential cookies to make our site work. With your consent, we may also use non-essential cookies to improve user experience and analyze website traffic. By clicking \"Accept\" you agree to our website's cookie use",
			"You can change your cookie settings at any time by clicking"
		]
	},
	meta: {
		index: {
			title: "Cake Toppers & Party Decor - Valley Arts",
			ogTitle: "Celebrate with Valley Arts - Cake Toppers & Party Decor",
			description:
				"Discover the best cake toppers, candles, and party decor at Valley Arts. Make your celebrations memorable with our unique and handcrafted items.",
			ogDescription:
				"Shop unique cake toppers, candles, and party decor to make your celebrations unforgettable. Explore Valley Arts for handcrafted and customized party essentials."
		},
		shop: {
			title: "Shop Cake Toppers & Party Decor - Valley Arts",
			ogTitle: "Shop the Best Cake Toppers & Party Decor",
			description:
				"Browse our collection of cake toppers, candles, and party decorations. Find everything you need for your next celebration at Valley Arts.",
			ogDescription:
				"Explore a wide range of cake toppers, candles, and party decor items at Valley Arts. Perfect for birthdays, weddings, and all celebrations."
		},
		shopProduct: {
			title: "Buy {productName} - Valley Arts",
			ogTitle: "Get {productName} at Valley Arts"
		},
		faq: {
			title: "FAQ - Valley Arts",
			ogTitle: "FAQ - Valley Arts",
			description:
				"Find answers to frequently asked questions about our cake toppers, candles, and party decor. Learn more about Valley Arts.",
			ogDescription:
				"Have questions? Find answers about our cake toppers, candles, and party decor at Valley Arts. Get all the information you need here."
		},
		about: {
			title: "About Us - Valley Arts",
			ogTitle: "About Valley Arts",
			description:
				"Learn about Valley Arts, your go-to source for cake toppers, candles, and party decor. Discover our story and our commitment to quality.",
			ogDescription:
				"Discover Valley Arts and our dedication to providing unique cake toppers, candles, and party decor. Learn about our journey and values."
		},
		orderCart: {
			title: "Your Cart - Valley Arts",
			ogTitle: "Your Cart - Valley Arts",
			description:
				"View and update the items in your cart. Get the best cake toppers, candles, and party decor at Valley Arts.",
			ogDescription:
				"Check your cart and make any necessary updates. Shop for unique cake toppers, candles, and party decor at Valley Arts."
		},
		orderCheckout: {
			title: "Checkout - Valley Arts",
			ogTitle: "Checkout - Valley Arts",
			description:
				"Complete your purchase of cake toppers, candles, and party decor. Enjoy secure checkout at Valley Arts.",
			ogDescription:
				"Finalize your purchase of cake toppers, candles, and party decor. Enjoy a secure and easy checkout process at Valley Arts."
		},
		orderReceipt: {
			title: "Order Confirmation - Valley Arts",
			ogTitle: "Order Confirmed - Valley Arts",
			description:
				"Your order has been placed! Find your order details and track your cake toppers, candles, and party decor at Valley Arts.",
			ogDescription:
				"Thank you for your purchase! View your order details and track your cake toppers, candles, and party decor at Valley Arts."
		},
		publicOffer: {
			title: "Public Offer - Valley Arts",
			ogTitle: "Public Offer - Valley Arts",
			description:
				"Terms of the public offer and the rules for using the Valley Arts service.",
			ogDescription:
				"Terms of the public offer and the rules for using the Valley Arts service."
		},
		privacyPolicy: {
			title: "Privacy Policy - Valley Arts",
			ogTitle: "Privacy Policy - Valley Arts",
			description: "Information on how Valley Arts collects, uses, and protects personal data.",
			ogDescription: "Information on how Valley Arts collects, uses, and protects personal data."
		}
	}
};
